import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Card } from '@zola/zola-ui';
import { isEmpty } from 'lodash';
import paperSvg from '../../../../../../assets/images/website/manage-redesign/congrats-paper.svg';
import giftSvg from '../../../../../../assets/images/website/manage-redesign/congrats-gift.svg';
import { getIsAdminView, getRelatedCardsFromCurrentSuite } from '../../../../../../cards/selectors/cardCatalogSelector';
import { CARD_TYPE } from '../../../../../../cards/constants/Cards';
import './CongratsBanner.styles.less';


const CongratsBanner = ({ hasRegistry, themeGroupTitle, isAdminView, relatedCards }) => {
  const [isBannerVisible, setIsBannerVisible] = useState(true);

  if (!isBannerVisible) {
    return null;
  }

  const getPath = (card) => {
    const basePlanningUrl = isAdminView ? '/wedding-planning/admin' : '/wedding-planning';

    if (isEmpty(card)) {
      return `${basePlanningUrl}/save-the-date/`;
    }

    const { urlSlug } = CARD_TYPE[card.type];

    return `${basePlanningUrl}/${urlSlug}/${card.suiteUUID}`;
  };


  const handleOnRegistryClick = () => {
    window.location.href = hasRegistry ? '/registry/checklist' : '/onboard/new';
  };

  const handleOnShopPaperProducts = () => {
    const card = relatedCards && relatedCards[0];
    const pathname = getPath(card);

    if (pathname) {
      browserHistory.push(pathname);
    }
  };

  return (
    <section className="mpr-congrats">
      <button onClick={() => setIsBannerVisible(false)} className="mpr-congrats__close-button">
        <i className="zolaicon zolaicon-close mpr-congrats__close-icon" />
      </button>
      <h3 className="mpr-congrats__title">
        <span className="mpr-congrats__title--first">Congrats on going live!</span>{' '}
        <span className="mpr-congrats__title--second">Most people do these things next:</span>
      </h3>
      <div className="mpr-congrats__group">
        <Card
          copy={`Shop paper products ${themeGroupTitle && !isEmpty(relatedCards) ? `in ${themeGroupTitle}` : ''}`}
          ctaIcon="zolaicon-chevron-right"
          iconSrc={paperSvg}
          onClick={handleOnShopPaperProducts}
        />
        <Card
          copy="Complete your Zola registry checklist"
          ctaIcon="zolaicon-chevron-right"
          iconSrc={giftSvg}
          onClick={handleOnRegistryClick}
        />
      </div>
    </section>
  );
};


CongratsBanner.propTypes = {
  hasRegistry: PropTypes.bool,
  themeGroupTitle: PropTypes.string.isRequired,
  isAdminView: PropTypes.bool.isRequired,
  relatedCards: PropTypes.arrayOf(PropTypes.shape({})),
};

const mapStateToProps = state => ({
  hasRegistry: state.user.userContext.has_registry,
  themeGroupTitle: state.wedding.themeGroupTitle,
  isAdminView: getIsAdminView(state),
  relatedCards: getRelatedCardsFromCurrentSuite(state)
});


export default connect(
  mapStateToProps
)(CongratsBanner);



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/WebAdmin/CongratsBanner/CongratsBanner.jsx